import { ThemeConfig } from 'core-ui';

export const systemColor = {
  primary: '#4759FF'
};

const theme: ThemeConfig = {
  token: {
    colorPrimary: systemColor.primary,
    borderRadius: 4
  },
  components: {
    Button: {},
    Select: {},
    Input: {},
    Table: {},
    Menu: {
      itemMarginInline: 0,
      itemMarginBlock: 0,
      itemBorderRadius: 0,
      activeBarWidth: 3,
      itemHeight: 40,
      iconSize: 18
    }
  }
};
export default theme;
